import { FC } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';

import css from './nibCardCheckList.module.sass';

interface NibCardCheckListProps {
  items: NibCardCheckListItem[];
  onChangeItems: (id: number | string, newState: boolean) => void;
  width?: number;
  height?: number;
}

interface ItemProps extends NibCardCheckListItem {
  onChange: (id: number | string, newState: boolean) => void;
}

interface NibCardCheckListItem {
  id: number | string;
  label: string;
  underlabel?: string;
  state: boolean;
  disabled?: boolean;
}

const Item: FC<ItemProps> = ({ id, label, state, disabled = false, onChange, underlabel }) => {
  return (
    <ListItem>
      <div className={css.inner}>
        <div>
          <p className={css.label}>{label}</p>
          {underlabel && <p className={css.underlabel}>{underlabel}</p>}
        </div>
        <div className={css.checkBox}>
          <Checkbox
            disabled={disabled}
            checked={state}
            onChange={(e) => {
              onChange(id, e.target.checked);
            }}
            color="primary"
          />
        </div>
      </div>
    </ListItem>
  );
};

const NibCardCheckList: FC<NibCardCheckListProps> = ({ items = [], onChangeItems, width, height }) => {
  return (
    <List className={css.list} dense style={{ width: width || '100%', maxHeight: height || '500px' }}>
      {/*@ts-ignore*/}
      <div style={{ width: '100%', height: '100%' }}>
        {items.map((item) => (
          <Item
            key={item.id}
            id={item.id}
            label={item.label}
            state={item.state}
            disabled={item.disabled}
            onChange={onChangeItems}
            underlabel={item.underlabel}
          />
        ))}
      </div>
    </List>
  );
};

export default NibCardCheckList;
